import { useEffect, useState } from "react";

const useContent = (conf) => {
    const [content, setContent] = useState(null);

    useEffect(() => {
      fetch(conf)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response error fetching content.json');
          }
          return response.json();
        })
        .then(data => setContent(data))
        .catch(error => console.error('There has been a problem fetching content.json:', error));
    }, [conf]);
  
  return content;
};

export default useContent;
